module.exports = __webpack_public_path__ + "img/11825383_L.bd26aa7b.png";